module.exports = __webpack_public_path__ + "static/media/hands-heart.38e3b789.svg";